export const SLIDE_WIDTH = 200;
export const MIN_SLIDE_HEIGHT = 95;

// The thumbnail is the container that contains the preview of the infograph
export const THUMBNAIL_MIN_WIDTH = 80;
export const THUMBNAIL_MIN_HEIGHT = 80;
export const THUMBNAIL_MAX_WIDTH = 144;
export const THUMBNAIL_MAX_HEIGHT = 220;
export const THUMBNAIL_PADDING = 16;

export const BORDER_WIDTH = 2;
